import React, { useEffect, useMemo } from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import useRouteName from "../../hooks/useRouteName.js";
import { Header as WebShellHeader } from "@bookingcom/web-shell";
import { BookingComLogoDarkBackgroundsMono } from "@bookingcom/bui-assets-react/brand";
import useUserAgent from "../../hooks/useUserAgent.js";
import styles from "./Header.module.css";
import { useLocation } from "react-router-dom";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { mcn } from "../../utils/mergeClassnames.js";
const SMALL_HEADER_PAGE_LIST = [
    "checkout-fare",
    "checkout-seat-selection",
    "checkout-sirf",
    "checkout-start",
    "checkout-ticket-type",
    "checkout-pax",
    "checkout-extras",
    "checkout-ryanair-confirmation",
    "checkout-payment",
    "checkout-collection",
    "pb-checkout-payment",
    "messenger",
    "messenger-ended"
];
const ALLOW_CURRENCY_PICKER_PAGE_LIST = [
    "home",
    "searchresults",
    "searchresults-outbound",
    "searchresults-inbound",
    "fly-anywhere",
    "deals"
];
function HeaderFallback() {
    return React.createElement(WebShellHeader, { logo: React.createElement(BookingComLogoDarkBackgroundsMono, null) });
}
export default function Header() {
    const location = useLocation();
    const routeName = useRouteName();
    const { isMobile } = useUserAgent();
    const { isWebview } = useUserAgent();
    const shouldExcludeCurrencySelectionForMdot = isMobile;
    const remoteHeader = useRemoteComponent({
        project: "web-shell",
        service: "header-mfe",
        path: "/TravellerHeader/Flights",
        type: "capla"
    }, {
        fallbackComponent: HeaderFallback
    });
    const remoteHeaderWithCurrencySelection = useRemoteComponent({
        project: "web-shell",
        service: "header-mfe",
        path: "/TravellerHeader/Flights/Currency",
        type: "capla"
    }, {
        fallbackComponent: HeaderFallback
    });
    const shouldRenderHeader = useMemo(() => !(routeName === "not-available" ||
        (isWebview && routeName.includes("checkout-pax")) ||
        (isMobile && routeName.includes("flightdetails")) ||
        (isWebview && routeName === "additional-flights-terms") ||
        (isWebview && routeName === "home") ||
        (isWebview && routeName === "confirmation") ||
        (isWebview && routeName === "pb-order-details") ||
        (isWebview && routeName === "pb-flight-details") ||
        (isWebview && routeName === "pb-add-baggage") ||
        (isWebview && routeName === "pb-cancel-order") ||
        (isWebview && routeName === "pb-cancel-order") ||
        (isWebview && routeName === "pb-checkout-payment") ||
        (isWebview && routeName === "pb-checkout-confirmation") ||
        (isWebview && routeName === "additional-flights-terms")), [isWebview, isMobile, routeName]);
    useEffect(() => {
        if (!isFeatureRunningClientSide("FLIGHTS_WEB_REMOTE_COMPONENT_REDIRECT_AFTER_LOGIN"))
            return;
        const headerElement = document.querySelector(".web-shell-header-mfe");
        if (!headerElement)
            return;
        headerElement.dispatchEvent(new Event("shell__navigate"));
    }, [location.pathname, location.search]);
    if (!shouldRenderHeader) {
        return React.createElement(React.Fragment, null);
    }
    const hideProductsBar = SMALL_HEADER_PAGE_LIST.includes(routeName) || (isMobile && routeName === "searchresults");
    const hideCurrencyPicker = !ALLOW_CURRENCY_PICKER_PAGE_LIST.includes(routeName);
    const { Component } = remoteHeader;
    const { Component: ComponentWithCurrencySelection } = remoteHeaderWithCurrencySelection;
    return (React.createElement("div", { className: mcn(hideProductsBar ? styles.hideProductsBar : "", hideCurrencyPicker ? styles.hideCurrencyPicker : "") }, shouldExcludeCurrencySelectionForMdot ? React.createElement(Component, null) : React.createElement(ComponentWithCurrencySelection, null)));
}
